import React from "react";

/**
 * DS StatusBadge — figma "StatusBadge" (dot 6px + 라벨, pill radius 30, px12 py2, gap 8, SemiBold 14/22).
 *   blue  4396:52835 / 4081:132019 / 4476:72754 — Blue/10 bg, dot·라벨 Text/Accent (활성화·재고연동 지점 등)
 *   gray  4476:72773 — BG/Paper bg, dot·라벨 Text/Primary (불가능)
 *   muted 4776:141670 — BG/Paper bg, dot·라벨 Text/Disabled (비활성화)
 *   white 4396:52832 — white bg + 1px cool gray 10 테두리, dot·라벨 Text/Secondary (등급정보 동기화 미완료)
 *   green — green/background + green/green (Chip_round 완료 4360:51653 색 재사용; 온보딩 카드 완료 항목)
 *
 * @param {object} props
 * @param {"blue"|"gray"|"muted"|"white"|"green"} [props.tone="blue"]
 * @param {React.ReactNode} props.label
 * @param {boolean} [props.dot=true]
 * @param {string} [props.className]
 */
const DSStatusBadge = ({ tone = "blue", label, dot = true, className = "" }) => (
  <span className={`ds-status-badge ds-status-badge--${tone} ${className}`}>
    {dot ? <span className="ds-status-badge__dot" aria-hidden /> : null}
    {label}
  </span>
);

export default React.memo(DSStatusBadge);
